import { ApiServiceImpl } from "../core/api.service.impl";
import { stores } from "../../stores/";
import KeyResolver from "key-did-resolver";
import { DID } from "dids";
import { verifyCacao } from "../auth/auth.service.impl";
export class SignerServiceImpl extends ApiServiceImpl {
    async signMessage(payload) {
        if (!stores.authStore.authSession) {
            return this.error(new Error("Signer not authenticated. Call authenticate() first"));
        }
        try {
            const dagJWS = await stores.authStore.authSession.did.createJWS(payload);
            const signedChatMessage = {
                id: payload.id,
                jws: dagJWS,
                cacao: [stores.authStore.authSession.cacao],
            };
            return this.success(signedChatMessage);
        }
        catch (e) {
            return this.error(e);
        }
    }
    async verifyMessage(signedMessage) {
        try {
            const did = new DID({ resolver: KeyResolver.getResolver() });
            const signedMessages = signedMessage.cacao.map((c, i) => {
                return {
                    id: signedMessage.id,
                    cacao: [c],
                    jws: {
                        payload: signedMessage.jws.payload,
                        link: signedMessage.jws.link,
                        signatures: [signedMessage.jws.signatures[i]],
                    },
                };
            });
            const verifyResults = await Promise.all(signedMessages.map(async (msg) => {
                // Verify cacao object
                verifyCacao(msg.cacao[0]);
                // Verify JWS
                const jwsResult = await did.verifyJWS(msg.jws);
                // Verify Cacao aud with JWS signer
                if (jwsResult.didResolutionResult.didDocument.id !== msg.cacao[0].p.aud) {
                    throw new Error("Invalid aud in Cacao");
                }
                return jwsResult;
            }));
            if (verifyResults.length > 0 && verifyResults[0].payload) {
                return this.success(verifyResults[0].payload);
            }
            else {
                return this.error(new Error("Failed to validate message"));
            }
        }
        catch (e) {
            return this.error(e);
        }
    }
    combineMessageRequests(messageRequests) {
        return messageRequests.reduce((prev, cur) => {
            if (!prev) {
                return cur.body.message.getDto();
            }
            else {
                prev.cacao.push(...cur.body.message.getDto().cacao);
                prev.jws.signatures.push(...cur.body.message.getDto().jws.signatures);
                return prev;
            }
        }, undefined);
    }
}
